/* ADD GROUPS */
export const GET_ANSWER = "GET_ANSWER"
export const GET_ANSWER_SUCCESS = "GET_ANSWER_SUCCESS"
export const GET_ANSWER_CLEAN = "GET_ANSWER_CLEAN"
export const GET_ANSWER_ERROR = "GET_ANSWER_ERROR"
